import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

type Size = 'sm' | 'base' | 'lg' | 'xl';

/**
 * Price component
 */
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'vp-price',
	templateUrl: './price.html',
})
export class PriceComponent extends BaseDirective {
	readonly price = input.required<number>();
	readonly currency = input.required<string>();
	readonly striked = input(false);
	readonly size = input<Size>('base');

	readonly priceFormatted = computed<Intl.NumberFormatPart[]>(() => {
		const formatter = new Intl.NumberFormat(this.language(), {
			style: 'currency',
			currency: this.currency(),
			currencyDisplay: 'narrowSymbol',
		});

		return formatter.formatToParts(this.price() / 100);
	});
}
